// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1492":"8d9ef48cd0fbaecd8e89","6663":"6dc355a93d650ec981aa","8063":"e78d100221f3772f80a3"}[chunkId] + ".js";
};